import * as Global from "styles/global/global.styles";
import { SxProps, Theme, useTheme } from '@mui/material/styles';


export function Container(){
  return {
    zIndex: Global.zIndex().foreground,
    display: "grid",
    placeItems: "center",
    m: "0",
    p: "3rem",
    height: Global.viewport().height,
  };
}

export function Card() {
  return {
    height: "100%",
    borderRadius: "30px",
    px: "2rem",
    py: "2rem",
    m: "0",
    maxHeight: "400px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    width: "100%",
  };
}

export function Title() {
  return {
    textAlign: "center",
    color: Global.colors().headers,
  };
}

export function Subtitle() {
  return {
    textAlign: "center",
  };
}

export function TextContainer() {
  return {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    p: "0",
    m: "0",
  };
}

export function Text() {
  return {
    fontSize: "100px",
    mb: "10px",
  };
}
